import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, HeartIcon, ClockIcon, CheckCircle2Icon, ArrowRightIcon, StarIcon } from 'lucide-react';
export function MarketingLandingPage() {
  return <div className="min-h-screen bg-white font-sans text-[#0B1220] flex flex-col" data-id="element-4406" data-mp="37h9qulliz91x">
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm" data-id="element-4407" data-mp="32nykelkmkuaj">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-4408" data-mp="3hd3281nicwi4">
          <Link to="/marketing" className="flex-shrink-0" data-id="element-4409" data-mp="3cejfhz13bgop">
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-6 md:h-7" data-id="element-4410" data-mp="3qeu7x6i1t3bz" />
          </Link>
          <Link to="/onboarding" className="bg-[#0EB4CC] text-white px-5 py-2.5 rounded-full font-bold text-sm hover:bg-[#0ca3b8] transition-colors shadow-sm" data-id="element-4411" data-mp="1w0jh4shw7z3k">
            Get Started
          </Link>
        </div>
      </header>

      <main className="flex-1 flex flex-col" data-id="element-4412" data-mp="27i8g3l2ijy54">
        {/* Hero Section */}
        <section className="bg-[#FFF1D3] px-4 py-16 md:py-24 relative overflow-hidden" data-id="element-4413" data-mp="2cjxoesycpxpi">
          <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-4414" data-mp="2hhqw5qfayzrw">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1F0648] mb-6 leading-[1.1] tracking-tight" data-id="element-4415" data-mp="2m9qy1oexo2r4">
              Your parents deserve better than a frustrated family IT guy.
            </h1>
            <p className="text-lg md:text-xl text-[#0B1220] mb-8 leading-relaxed max-w-2xl mx-auto opacity-90" data-id="element-4416" data-mp="2v8vw6tml1u2r">
              Caveo is the first digital safety platform that actually teaches
              your parents how to stay safe online, so you can stop fixing their
              Wi-Fi and start enjoying your weekends again.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-4417" data-mp="15xbzon0tkwb8">
              <Link to="/onboarding" className="w-full sm:w-auto bg-[#1F0648] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#2d096b] transition-all shadow-lg flex items-center justify-center gap-2" data-id="element-4418" data-mp="1aw6ihoysekvc">
                Start free 7-day trial
                <ArrowRightIcon size={20} data-id="element-4419" data-mp="1cp7jaabdzlae" />
              </Link>
              <p className="text-sm text-[#1F0648] font-medium opacity-75 sm:hidden mt-2" data-id="element-4420" data-mp="17ro7dh25vklm">
                No credit card required
              </p>
            </div>
            <div className="hidden sm:flex items-center justify-center gap-2 mt-6 text-sm text-[#1F0648] font-medium opacity-80" data-id="element-4421" data-mp="1gtp329hqxyl6">
              <CheckCircle2Icon size={16} className="text-[#0EB4CC]" data-id="element-4422" data-mp="1vgqmoi9bp1cy" /> Cancel
              anytime
              <span className="mx-2" data-id="element-4423" data-mp="1qk9vtgaqo8w6">•</span>
              <CheckCircle2Icon size={16} className="text-[#0EB4CC]" data-id="element-4424" data-mp="24iq2x8cik1eu" /> Takes 3
              minutes
            </div>
          </div>

          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-4425" data-mp="20f1wwu3j5dvp">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-[#0EB4CC] rounded-full mix-blend-multiply filter blur-3xl opacity-20" data-id="element-4426" data-mp="2j3cfx04tn3l9"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-[#1F0648] rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-4427" data-mp="2a5jude8iazpf"></div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="bg-white px-4 py-16 md:py-24" data-id="element-4428" data-mp="20dw8rtymscvv">
          <div className="max-w-7xl mx-auto" data-id="element-4429" data-mp="255nu9q2xjsf5">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16" data-id="element-4430" data-mp="256fn4t557c1q">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] mb-4" data-id="element-4431" data-mp="1rf26bmymcsae">
                Peace of mind for them. Time back for you.
              </h2>
              <p className="text-[#0B1220] opacity-80 text-lg" data-id="element-4432" data-mp="1vdhz67hdsuvq">
                We replace confusing tech jargon with plain-English guidance
                that builds genuine digital confidence.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-4433" data-mp="2ot4000itkbpj">
              {/* Benefit 1 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4434" data-mp="2kqqrx5glo1pl">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4435" data-mp="2fypjxvqgsx5d">
                  <ShieldCheckIcon size={28} className="text-[#1F0648]" data-id="element-4436" data-mp="2b0nyj45kglqq" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4437" data-mp="263ntmwkgdp17">
                  Stop the Scams
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4438" data-mp="215clcq9t3ml3">
                  Proactive education helps your parents spot phishing, fake
                  alerts, and social engineering before they click.
                </p>
              </div>

              {/* Benefit 2 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4439" data-mp="3rdcuofayv3mv">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4440" data-mp="3u054mi6tp1jj">
                  <ClockIcon size={28} className="text-[#1F0648]" data-id="element-4441" data-mp="2t10bv22btet" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4442" data-mp="7kj1ok7zzw0b">
                  Reclaim Your Time
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4443" data-mp="cjnd7hiea5tt">
                  No more emergency tech support calls during dinner. We handle
                  the repetitive questions so you don't have to.
                </p>
              </div>

              {/* Benefit 3 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4444" data-mp="3kyxjl1tbhx7e">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4445" data-mp="3p2c0dup2yhlw">
                  <HeartIcon size={28} className="text-[#1F0648]" data-id="element-4446" data-mp="108ez5r5e5ry5" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4447" data-mp="1498n2kiu36r1">
                  Built for Boomers
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4448" data-mp="31daa24tpazkf">
                  Zero jargon. No downloads required. Just clear, step-by-step
                  guidance designed specifically for older adults.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="bg-[#1F0648] px-4 py-16 md:py-24 text-white" data-id="element-4449" data-mp="2hmouv37jlt10">
          <div className="max-w-7xl mx-auto" data-id="element-4450" data-mp="2dllg6k18e31d">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16" data-id="element-4451" data-mp="2dmwi0eb490pu">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-4452" data-mp="2rdjedztemeir">
                How Caveo works
              </h2>
              <p className="text-gray-300 text-lg" data-id="element-4453" data-mp="2mli068coedq3">
                A simple, dignified approach to digital safety.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-4454" data-mp="1txvu8tfz6x02">
              {/* Connecting line for desktop */}
              <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-0.5 bg-[#2d096b] z-0" data-id="element-4455" data-mp="9eimizkmrglm"></div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4456" data-mp="e73ctr4bvbke">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4457" data-mp="fyagh9ks56d">
                  1
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4458" data-mp="t42gx4zz0ma4">
                  Take the Assessment
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4459" data-mp="x31s37capfa0">
                  A quick 3-minute quiz identifies your family's specific
                  vulnerabilities and current tech setup.
                </p>
              </div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4460" data-mp="33v2o0i2hs40a">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4461" data-mp="38uowyfbaey3a">
                  2
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4462" data-mp="3vinipom8qqpa">
                  Get a Custom Plan
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4463" data-mp="3qkvgo1rvto7d">
                  We generate a personalized curriculum focused only on what
                  they actually need to know.
                </p>
              </div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4464" data-mp="n2lmzb8bdxtv">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4465" data-mp="i4siqnqkndw8">
                  3
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4466" data-mp="8cegltvl059j">
                  Learn & Secure
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4467" data-mp="1134u8g4ygzuz">
                  They complete bite-sized, jargon-free lessons that build real
                  confidence and secure their accounts.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-[#FFF1D3] px-4 py-16 md:py-24" data-id="element-4468" data-mp="1ibxo1jgtp0h0">
          <div className="max-w-7xl mx-auto" data-id="element-4469" data-mp="1iejwrmfg9m0t">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] text-center mb-12" data-id="element-4470" data-mp="1nbtsfjtfmtx3">
              Loved by families
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-4471" data-mp="1saejotqpi39e">
              <div className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-4472" data-mp="1wap070c4kc2i">
                <div className="flex gap-1 mb-4 text-[#0EB4CC]" data-id="element-4473" data-mp="212ouod9fecrp">
                  <StarIcon size={20} fill="currentColor" data-id="element-4474" data-mp="2621qvom6sw6y" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4475" data-mp="261jmu5ta9doh" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4476" data-mp="2b1o43y20mcfr" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4477" data-mp="2az1mt6pboikc" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4478" data-mp="2g1afs3273kmg" />
                </div>
                <p className="text-[#0B1220] italic mb-6 leading-relaxed" data-id="element-4479" data-mp="1rt5cjqx63axn">
                  "My dad almost lost $4,000 to a phishing scam last year. Since
                  starting Caveo, he actually understands what to look for. And
                  the best part? He hasn't called me to fix his iPad in two
                  months."
                </p>
                <div className="flex items-center gap-3" data-id="element-4480" data-mp="25m3fbybxw5b8">
                  <div className="w-10 h-10 bg-[#1F0648] rounded-full flex items-center justify-center text-white font-bold" data-id="element-4481" data-mp="2ai1ztau5d36d">
                    S
                  </div>
                  <div data-id="element-4482" data-mp="2jj9uzk1d9nw8">
                    <p className="font-bold text-[#1F0648]" data-id="element-4483" data-mp="2jkuqpczf3cvo">Sarah M.</p>
                    <p className="text-sm text-gray-500" data-id="element-4484" data-mp="2oimk6bfpn71z">
                      Daughter & "Family IT Dept"
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-4485" data-mp="u4lgnd97tvvk">
                <div className="flex gap-1 mb-4 text-[#0EB4CC]" data-id="element-4486" data-mp="u6xzdsmssa9o">
                  <StarIcon size={20} fill="currentColor" data-id="element-4487" data-mp="mm46r5xfgf22" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4488" data-mp="huvwk7o9wpnu" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4489" data-mp="htb2sk9s9ar1" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4490" data-mp="curfogjgdsx3" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4491" data-mp="ct6ggdm71lsw" />
                </div>
                <p className="text-[#0B1220] italic mb-6 leading-relaxed" data-id="element-4492" data-mp="7y99dc8h5min">
                  "I was skeptical that an app could teach my 72-year-old mom
                  about password managers, but the plain-English approach really
                  works. It treats her with dignity instead of talking down to
                  her."
                </p>
                <div className="flex items-center gap-3" data-id="element-4493" data-mp="rl6zbqw80st5">
                  <div className="w-10 h-10 bg-[#0EB4CC] rounded-full flex items-center justify-center text-white font-bold" data-id="element-4494" data-mp="rmrspd6su5pf">
                    M
                  </div>
                  <div data-id="element-4495" data-mp="3c938ory1s0ff">
                    <p className="font-bold text-[#1F0648]" data-id="element-4496" data-mp="3cd0pv812ehwo">Michael T.</p>
                    <p className="text-sm text-gray-500" data-id="element-4497" data-mp="3dslacxei8vhh">Son & Caregiver</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Teaser / Final CTA */}
        <section className="bg-white px-4 py-16 md:py-24 text-center" data-id="element-4498" data-mp="38sqjuuyn67wy">
          <div className="max-w-3xl mx-auto" data-id="element-4499" data-mp="38qvzbhra8hte">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] mb-6" data-id="element-4500" data-mp="2v0sfexfvl074">
              Protect your family today
            </h2>
            <p className="text-lg text-[#0B1220] opacity-80 mb-8 max-w-xl mx-auto" data-id="element-4501" data-mp="2ztlmhrytgkmd">
              Get comprehensive digital safety education for the whole family
              for less than the cost of one tech support visit.
            </p>

            <div className="bg-[#f8f9fa] rounded-2xl p-8 max-w-md mx-auto border border-gray-200 mb-8" data-id="element-4502" data-mp="2c2g4b65elg8w">
              <h3 className="text-2xl font-bold text-[#1F0648] mb-2" data-id="element-4503" data-mp="2g3tefsfj45lm">
                Family Plan
              </h3>
              <div className="flex items-end justify-center gap-1 mb-6" data-id="element-4504" data-mp="1xezcc2cuplgg">
                <span className="text-4xl font-extrabold text-[#0B1220]" data-id="element-4505" data-mp="1sgo4fx649l0v">
                  $19.99
                </span>
                <span className="text-gray-500 mb-1" data-id="element-4506" data-mp="26gyxn6uwfbp7">/month</span>
              </div>
              <ul className="text-left space-y-3 mb-8" data-id="element-4507" data-mp="21hm7ac4tjmhv">
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4508" data-mp="21g1d4nmf25kj">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4509" data-mp="2gdlgjq3nzsol" />
                  <span data-id="element-4510" data-mp="2bdfrmhos4ka7">Up to 5 family members</span>
                </li>
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4511" data-mp="2p6f92p84goke">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4512" data-mp="2l53fy9q1hl7g" />
                  <span data-id="element-4513" data-mp="2z30ehbo201or">Full curriculum access</span>
                </li>
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4514" data-mp="2u7cnqrtxb0h5">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4515" data-mp="3e8ny7t0k1xty" />
                  <span data-id="element-4516" data-mp="3i7wup5mzc9t7">Family dashboard & alerts</span>
                </li>
              </ul>
              <Link to="/onboarding" className="block w-full bg-[#0EB4CC] text-white px-6 py-4 rounded-full font-bold text-lg hover:bg-[#0ca3b8] transition-colors shadow-md" data-id="element-4517" data-mp="3n0zpti7enrbi">
                Start 7-Day Free Trial
              </Link>
            </div>
            <p className="text-sm text-gray-500" data-id="element-4518" data-mp="2zbdq8tn4fa2z">
              Cancel anytime. No commitment.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#1F0648] text-white py-12 px-4 border-t border-[#2d096b]" data-id="element-4519" data-mp="39a2ydup7tg61">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-4520" data-mp="jkitthgh3atv">
          <div className="flex items-center gap-2" data-id="element-4521" data-mp="ohrf3qwx3uzc">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-6 opacity-90" data-id="element-4522" data-mp="oknfrn05gxrh" />
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-4523" data-mp="1zaa06fb3u9rt">
            <Link to="/about-us" className="hover:text-white transition-colors" data-id="element-4524" data-mp="1ucibrv9o55sd">
              About
            </Link>
            <Link to="/pricing" className="hover:text-white transition-colors" data-id="element-4525" data-mp="1qbes0xoi2plv">
              Pricing
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-4526" data-mp="1l9pk3qwkqs20">
              Privacy Policy
            </Link>
          </div>
          <div className="text-sm text-gray-500" data-id="element-4527" data-mp="1bdco2mdk4243">
            &copy; {new Date().getFullYear()} Caveo. All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}